<template>
  <div class="VolleyballInfo">
    <MatchNotice />
  </div>
</template>

<script>
import MatchNotice from '@comm/components/MatchNotice.vue'
export default {
  name: 'VolleyballNotice',
  props: {
    
  },
  data() {
    return {

    }
  },
  components: {
    MatchNotice
  },
  mounted() {},
  methods: {
    
  },
  watch: {},
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/comm/components/match/volleyball/components/VolleyballNotice.vue